import React, { Component } from 'react';

import { BackToTopAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { number } from '@philips-emr/tws-core/lib/component/prop-types';
import { getViewportElement, onViewportScroll } from '@philips-emr/tws-utils';

import { ReactComponent as NavigationUp } from '../../../resources/assets/components/arrow-up-navigation.svg';

import './back-to-top.scss';

@AwesomeComponent({ type: ComponentType.NAVIGATION, api: BackToTopAPI })
class BackToTop extends Component {

  static propTypes = {
    minVisibleHeight: number,
  };

  static defaultProps = {
    minVisibleHeight: 0,
  };

  state = {
    visible: false,
  };

  componentDidMount() {
    this.viewport = getViewportElement(true);

    this.unlisten = onViewportScroll(this.updateVisibility);

    this.updateVisibility();
  }

  componentDidUpdate(prevProps) {
    const { minVisibleHeight } = this.props;

    if (minVisibleHeight !== prevProps.minVisibleHeight) {
      this.updateVisibility();
    }
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  getScrollPercentage() {
    const { scrollTop, scrollHeight, clientHeight } = this.viewport;
    const onePercent = (scrollHeight - clientHeight) / 100;
    const scrollPercentage = Math.ceil(scrollTop / onePercent);
    return scrollPercentage || 0;
  }

  updateVisibility = () => {
    const { minVisibleHeight } = this.props;
    const { visible } = this.state;

    const scrollPercentage = this.getScrollPercentage();

    if (!visible && scrollPercentage >= minVisibleHeight) {
      this.setState({ visible: true });
    } else if (visible && scrollPercentage < minVisibleHeight) {
      this.setState({ visible: false });
    }
  };

  onClick = () => {
    this.viewport.scrollTo({ top: 0, behavior: 'smooth' });
  };

  renderButton() {
    const { visible } = this.state;

    if (!visible) {
      return null;
    }

    return (
      <button className="c-back-to-top" onClick={this.onClick}>
        <NavigationUp fill="#FFF" />
      </button>
    );
  }

  render() {
    return (
      this.renderButton()
    );
  }
}

export default BackToTop;
